export default __webpack_public_path__ + "static/media/winner_2.2af6745c.jpg";